import { render, staticRenderFns } from "./SendContent.vue?vue&type=template&id=7e619e1f&scoped=true&"
import script from "./SendContent.vue?vue&type=script&lang=js&"
export * from "./SendContent.vue?vue&type=script&lang=js&"
import style0 from "./SendContent.vue?vue&type=style&index=0&id=7e619e1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e619e1f",
  null
  
)

component.options.__file = "SendContent.vue"
export default component.exports